import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useParams, Link, useNavigate } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_maintenance_alert_detail = () => {
  useAuthRedirect();
  const { id, branch } = useParams(); 
  const [vehicleResult, setVehicle] = useState([]);
  const storedBranch = localStorage.getItem("branch"); 
  const [selectedBranch, setSelectedBranch] = useState(storedBranch || ""); 
  const navigate = useNavigate();
  const [header, setHeader] = useState({});
  const [cum, setCum] = useState({});

  const canView  = hasPermission("Vehicle Maintenance Alert", "view");

  // Fetch vehicle details report when the component mounts
  useEffect(() => {
    axios.get(`https://rfs2.infraconsoft.net.in/api/get_veh_main_alert_report_api/${id}`)
      .then((response) => {
        setVehicle(response.data.vehicles);
      })
      .catch((error) => {
        console.error("Error fetching vehicle details:", error);
      });
  }, [id]);

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_veh_detail1_reportheader_api?vcode=${id}&branch=${branch}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                vehicle_type: items[0].vehicle_type || "N/A",
                vehicle_name: items[0].vehicle_name || "N/A",
                vehicle_code: items[0].vehicle_code || "N/A",
                vehicle_number: items[0].vehicle_number || "N/A",
            };

            setHeader(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [id, branch]); 


  useEffect(() => {
    const fetchCumTot = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_veh_detail1_cumulative_api?vcode=${id}`);
        if (response.data && response.data.cumulativeHrs?.length > 0) {
            const items = response.data.cumulativeHrs;

            const storeReqHeader = {
                total_combined: items[0].total_combined || "N/A",
                vehicle_basis: items[0].vehicle_basis || "N/A",
                
            };

            setCum(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchCumTot();
  }, [id]); 

   if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
           <div className="back-div">
                      <h2 className="add-txt">Vehicle Maintenance - Details</h2>
                      <Link to={`/vehicle_maintenance_alert`}><p className="back-button"><i className="fa-solid fa-backward"></i> Back</p></Link>
                      </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" name="vehicle_code" value={header.vehicle_code} readOnly/>

              </div>
              <div className="form-group">
                <label>Vehicle Type :</label>
                <input type="text" name="vehicle_type" value={header.vehicle_type} readOnly/>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Vehicle Name :</label>
                <input type="text" name="vehicle_name" value={header.vehicle_name} readOnly />
              </div>
              <div className="form-group">
                <label>Vehicle Number :</label>
                <input type="text" name="vehicle_number" value={header.vehicle_number} readOnly />
              </div>
            </div>           
            
            <div className="content-table">
            <table>
  <thead>
    <tr>
      <th>S.No</th>
      <th>Description</th>
      <th>Oil Grade</th>
      <th>Last Changed Hr/Km</th>
      <th>Service Hr/Km</th>
      <th>Next Service Cumulative Hr/Km</th>
      <th>Current Cum Hr/Km</th>
      <th>Remaining-Hours</th>
      <th>Alerts</th>
    </tr>
  </thead>
  <tbody>
  {vehicleResult.length > 0 ? (
    vehicleResult.map((item, index) => {
      const changing_hrs = item.changing_hrs ? parseFloat(item.changing_hrs) : 0;
      const last_modified_hr = item.last_modified_hr ? parseFloat(item.last_modified_hr) : 0;

      // Next service due
      const tot = changing_hrs + last_modified_hr;

      // Current cumulative (depends on vehicle_basis)
      const currentCum =
        cum.vehicle_basis === "Hour"
          ? Number(item.tot1 || 0)
          : Number(item.tot2 || 0);

      // Remaining hrs/km
      const remaining =
        tot > currentCum ? (tot - currentCum).toFixed(2) : "Level Crossed";

      // Alert logic
      const showAlert = currentCum >= tot || (tot - currentCum) <= 5;

      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item.fld_des}</td>
          <td>{item.oilgrade}</td>
          <td>{item.last_modified_hr}</td>
          <td>{item.changing_hrs}</td>
          <td>{tot.toFixed(2)}</td>
          <td>{currentCum.toFixed(2)}</td>
          <td>{remaining}</td>
          <td>
            {showAlert && (
              <h3 style={{ color: "red" }}>Need to Change</h3>
            )}
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="10">No Data Available</td>
    </tr>
  )}
</tbody>

</table>
            </div>
          </form>
        </div>

      
      </div>
    </div>
  );
};

export default Vehicle_maintenance_alert_detail;
